import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredModule }) => {
    const { userData, loading, currentUser } = useAuth();

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center vh-100">Loading...</div>;
    }

    if (!currentUser || !userData) {
        return <Navigate to="/admin/login" replace />;
    }

    if (userData.role === 'admin') {
        return children;
    }

    if (requiredModule) {
        const hasPermission = userData.permissions && userData.permissions[requiredModule];
        
        if (!hasPermission) {
            return <Navigate to="/admin" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;